import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Events from "@/pages/Events";
import GetInvolved from "@/pages/GetInvolved";
import MemberLogin from "@/pages/MemberLogin";
import MemberDashboard from "@/pages/MemberDashboard";
import Admin from "@/pages/Admin";
import Links from "@/pages/Links";
import CustomPage from "@/pages/CustomPage";
import About from "@/pages/About";
import PaymentSuccess from "@/pages/PaymentSuccess";

function AppRouter() {
  const location = useLocation();
  // Detect the OAuth callback synchronously during render (prevents race conditions).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/about" element={<About />} />
      <Route path="/get-involved" element={<GetInvolved />} />
      <Route path="/member-login" element={<MemberLogin />} />
      <Route path="/member-dashboard" element={<MemberDashboard />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/links" element={<Links />} />
      <Route path="/p/:slug" element={<CustomPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
